var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1385 4.36722C37.9148 3.52311 37.4784 2.75356 36.8729 2.1352C36.2673 1.51684 35.5137 1.07125 34.687 0.8428C31.6605 0 19.48 0 19.48 0C19.48 0 7.29892 0.025511 4.27246 0.868311C3.44577 1.09678 2.69212 1.54239 2.08655 2.16078C1.48098 2.77916 1.04464 3.54875 0.820964 4.39289C-0.0944699 9.88369 -0.449583 18.2504 0.8461 23.5216C1.0698 24.3657 1.50615 25.1352 2.11172 25.7536C2.71728 26.3719 3.47093 26.8175 4.2976 27.046C7.32406 27.8888 19.5049 27.8888 19.5049 27.8888C19.5049 27.8888 31.6855 27.8888 34.7118 27.046C35.5385 26.8176 36.2922 26.372 36.8978 25.7536C37.5034 25.1353 37.9398 24.3657 38.1635 23.5216C39.129 18.023 39.4265 9.66156 38.1385 4.36738V4.36722Z",
    fill: "#909399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6032 19.9205L25.7079 13.9443L15.6032 7.9682V19.9205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.b913549f22a4ebeb0490af755a41d8a5.svg";
export { ForwardRef as ReactComponent };